import { useState } from 'react';
import { App, Modal } from 'antd';
import type { Collection } from '@core/entities/Collection';
import { MarkdownEditor } from '@presentation/components/workbench/MarkdownEditor';
import { useUpdateCollection } from '@presentation/hooks/useCollections';

interface CollectionDocsModalProps {
  workspaceId: string;
  collection: Collection;
  open: boolean;
  onClose: () => void;
}

export const CollectionDocsModal = ({
  workspaceId,
  collection,
  open,
  onClose,
}: CollectionDocsModalProps) => {
  const { message } = App.useApp();
  const updateCollection = useUpdateCollection(collection.id, workspaceId);
  const [description, setDescription] = useState(collection.description ?? '');

  const [wasOpen, setWasOpen] = useState(open);
  if (open !== wasOpen) {
    setWasOpen(open);
    if (open) {
      setDescription(collection.description ?? '');
    }
  }

  const handleSave = () => {
    updateCollection.mutate(
      { description },
      {
        onSuccess: () => {
          void message.success('Documentation saved');
          onClose();
        },
      },
    );
  };

  return (
    <Modal
      open={open}
      title={`Documentation — ${collection.name}`}
      onCancel={onClose}
      onOk={handleSave}
      confirmLoading={updateCollection.isPending}
      width={720}
      destroyOnHidden
    >
      <MarkdownEditor
        value={description}
        onChange={setDescription}
        placeholder="Document what this collection contains, how to use it, and any setup notes…"
        minHeight={320}
      />
    </Modal>
  );
};
